import ContentWrapper from "../../../../core/ui/components/Layout/ContentWrapper";
import {
    useNavigate,
    useOutletContext,
} from "react-router-dom";
import SeleccionSede from "../../../../core/ui/components/SeleccionSede";

const SedesSolicitudes = () => {
    const navigate = useNavigate();
    const { ciudad, setSede } = useOutletContext();

    const onClickSede = (sede) => {
        setSede(sede);
        navigate("/solicitudes/areas");
    };

    return (
        <ContentWrapper>
            <div className="d-sm-flex align-items-center justify-content-center mb-4">
                <div className="h3 mb-0 text-purple-mac">
                    <i className="fas fa-city"></i> Sede de Soporte
                </div>
            </div>
            <SeleccionSede
                onClickSede={onClickSede}
                parametrosBusquedaSedes={{
                    ciudad_id: ciudad.id,
                    status: 1,
                }}
            />
        </ContentWrapper>
    );
};

export default SedesSolicitudes;
